var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgQrcodeSolid = function SvgQrcodeSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    className: "svgr-icon"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 5v8h2v2h2v-2h4V5Zm8 8v2h2v2h-4v2H5v8h8v-8h6v-2h-2v-2h4v-2h2v2h2v-2h2V5h-8v8Zm12 2v2h2v-2Zm0 2h-2v2h2Zm0 2v2h2v-2Zm0 2h-2v-2h-2v2h-5v6h2v-4h4v2h2v-2h1Zm-3 4h-2v2h2Zm1-8v-2h-2v2Zm-12 0v-2H9v2Zm-4-2H5v2h2Zm8-10v4h-1v2h1v1h2V9h1V7h-1V5ZM7 7h4v4H7Zm14 0h4v4h-4ZM8 8v2h2V8Zm14 0v2h2V8ZM7 21h4v4H7Zm1 1v2h2v-2Zm17 3v2h2v-2Z"
  })));
};
export default SvgQrcodeSolid;